import { alpha, Box, BoxProps, Typography } from '@mui/material';

type CenteredEmptyStateProps = {
    message: React.ReactNode;
    height?: BoxProps['height'];
};

const CenteredEmptyState = ({ message, height = 300 }: CenteredEmptyStateProps) => (
    <Box display="flex" alignItems="center" justifyContent="center" height={height} width="100%">
        <Typography fontSize={16} fontWeight={500} bgcolor={alpha('#212B36', 0.1)} borderRadius="3px" p="10px">
            {message}
        </Typography>
    </Box>
);

export { CenteredEmptyState };
